import { Configuration } from "@/config";

const {
  config: {
    CLIENT_ID,
    AUTHORITY,
    REDIRECT_URL,
    API_SCOPE,
    POLICY_SIGN_IN
  },
} = new Configuration();

const authoritySignIn = AUTHORITY?.replace("{policy}", POLICY_SIGN_IN);

export const msalConfig = {
  // todo: inject the following values via config.

  scope: API_SCOPE,
  auth: {
    clientId: CLIENT_ID,
    authority: authoritySignIn,
    knownAuthorities: [authoritySignIn],
    redirectUri: REDIRECT_URL,
    postLogoutRedirectUri: REDIRECT_URL,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
};
